import { createTheme } from '@mui/material/styles';
import palette from './palette';
import shadows from './shadows';
import typography from './typography';

const MUITheme = createTheme({
  palette,
  shadows,
  typography: {
    ...typography,
    fontFamily: "'Sofia Pro', 'Arial', 'Helvetica', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          color: palette.text.primary,
          fontFamily: "'Sofia Pro', 'Arial', 'Helvetica', sans-serif",
          fontWeight: 400,
          fontSize: '1rem',
          lineHeight: 1.5,
          backgroundColor: '#f4f6f8',
          // Add any other body styles you want to override
        },
      },
    },
    MuiPickersBasePicker: {
      styleOverrides: {
        container: {
          '& .MuiTypography-h4.MuiPickersToolbarText-toolbarTxt': {
            fontSize: '28px',
          },
          '& .MuiTypography-subtitle1.MuiPickersToolbarText-toolbarTxt': {
            fontSize: '18px',
          },
          '& .MuiTypography-root.MuiPickersYear-root': {
            fontSize: '16px',
          },
          '& .MuiTypography-root.MuiPickersYear-root.MuiPickersYear-yearSelected': {
            fontSize: '24px',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.714rem',
          maxWidth: '200px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          color: '#354558',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: palette.divider,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        filledWarning: {
          backgroundColor: '#e65100',
        },
        root: {
          '&.custom-warning-alert': {
            backgroundColor: '#fff3cd',
            color: '#856404',
            border: '1px solid #ffeaa7',
            alignItems: 'center',
            '& .MuiAlert-icon': {
              color: '#856404',
            },
            '& .MuiAlert-message': {
              fontWeight: 500,
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& div[data-lastpass-icon-root=true]': {
            display: 'none',
          },
        },
      },
    },
  },
  props: {
    MuiTooltip: {
      arrow: true,
    },
    MuiInputBase: {
      inputProps: {
        'data-1p-ignore': true,
        'data-lpignore': true,
      },
    },
  },
});

export default MUITheme;
